import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

/* CSS */
import shared from '../styles/shared.module.css';

/* Utils */
import { validatePassword } from '../utils/passwordUtils';

/* Components */
import AuthHeader from '../components/layout/AuthHeader';
import PasswordInput from '../components/auth/PasswordInput';
import PasswordChecklist from '../components/auth/PasswordChecklist';

const PasswordSetupPage = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const email = location.state?.email || "";
    const next = location.state?.next || null;

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showErrors, setShowErrors] = useState(false);

    // Check validation on every keystroke
    const criteria = validatePassword(password, confirmPassword);
    const isFormValid = Object.values(criteria).every(Boolean);

    return (
        <>
            <AuthHeader currentStep="password" />

            <div className={shared.authBody}>
                <div className={shared.authTitleWrapper}>
                    <div className={shared.authTitle} style={{ fontWeight: '900' }}>Create your password</div>
                </div>

                <div className={shared.authBodyInput}>

                    {/* Password field */}
                    <PasswordInput
                        label="Your password"
                        value={password}
                        onChange={setPassword}
                        labelStyle={{ fontWeight: '600' }}
                    />

                    {/* Password criteria list */}
                    <PasswordChecklist criteria={criteria} showErrors={showErrors} />

                    {/* Confirm password */}
                    <PasswordInput
                        label="Confirm your password"
                        value={confirmPassword}
                        onChange={setConfirmPassword}
                        labelStyle={{ fontWeight: '600', marginTop: '18px' }}
                    />

                    {/* Match criteria */}
                    <PasswordChecklist criteria={criteria} isConfirmPassword={true} showErrors={showErrors} />

                    {/* Submit button */}
                    <button
                        className={shared.authButton}
                        style={{ marginTop: '24px' }}
                        onClick={() => {
                            if (!isFormValid) {
                                setShowErrors(true);
                                return;
                            }
                            navigate('/profilesetup', { state: { email, password, next } });
                        }}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </>
    );
};

export default PasswordSetupPage;
